import { SxProps, Theme } from '@mui/material';

export const FullScreenLoaderMainStyles: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  width: '100vw',
};

export const FullScreenLoaderWrapperStyles: SxProps<Theme> = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
};
